/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Payout
 * Payout application
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { payinKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType } from '../../shared/api/kyMutator';
import {
    type GoogleRpcStatus,
    type PayinTraderV1BalanceResponse,
    type PayinTraderV1GetMeResponse,
    type PayinTraderV1RegisterRequest,
    type PayinTraderV1RegisterResponse,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Полуить инофрмацию о профиле трейдера.
 */
export const getTraderPayinTraderServiceGetMeUrl = () => {
    return '/v1/trader';
};

export const traderPayinTraderServiceGetMe = async (options?: RequestInit): Promise<PayinTraderV1GetMeResponse> => {
    return payinKyMutator<PayinTraderV1GetMeResponse>(getTraderPayinTraderServiceGetMeUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getTraderPayinTraderServiceGetMeQueryKey = () => {
    return ['/v1/trader'] as const;
};

export const getTraderPayinTraderServiceGetMeQueryOptions = <
    TData = Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>,
    TError = ErrorType<GoogleRpcStatus>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>, TError, TData>>;
    request?: SecondParameter<typeof payinKyMutator>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getTraderPayinTraderServiceGetMeQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>> = ({ signal }) =>
        traderPayinTraderServiceGetMe({ signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraderPayinTraderServiceGetMeQueryResult = NonNullable<
    Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>
>;
export type TraderPayinTraderServiceGetMeQueryError = ErrorType<GoogleRpcStatus>;

export function useTraderPayinTraderServiceGetMe<
    TData = Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayinTraderServiceGetMe<
    TData = Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayinTraderServiceGetMe<
    TData = Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Полуить инофрмацию о профиле трейдера.
 */

export function useTraderPayinTraderServiceGetMe<
    TData = Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinTraderServiceGetMe>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getTraderPayinTraderServiceGetMeQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Подать заявку на регистрацию выплатного трейдера.
 */
export const getTraderPayinTraderServiceRegisterUrl = () => {
    return '/v1/trader';
};

export const traderPayinTraderServiceRegister = async (
    payinTraderV1RegisterRequest: PayinTraderV1RegisterRequest,
    options?: RequestInit,
): Promise<PayinTraderV1RegisterResponse> => {
    return payinKyMutator<PayinTraderV1RegisterResponse>(getTraderPayinTraderServiceRegisterUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payinTraderV1RegisterRequest),
    });
};

/**
 * @summary Получить баланс трейдера.
 */
export const getTraderPayinTraderServiceBalanceUrl = () => {
    return '/v1/trader/balance';
};

export const traderPayinTraderServiceBalance = async (options?: RequestInit): Promise<PayinTraderV1BalanceResponse> => {
    return payinKyMutator<PayinTraderV1BalanceResponse>(getTraderPayinTraderServiceBalanceUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getTraderPayinTraderServiceBalanceQueryKey = () => {
    return ['/v1/trader/balance'] as const;
};

export const getTraderPayinTraderServiceBalanceQueryOptions = <
    TData = Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>, TError, TData>>;
    request?: SecondParameter<typeof payinKyMutator>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getTraderPayinTraderServiceBalanceQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>> = ({ signal }) =>
        traderPayinTraderServiceBalance({ signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraderPayinTraderServiceBalanceQueryResult = NonNullable<
    Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>
>;
export type TraderPayinTraderServiceBalanceQueryError = ErrorType<GoogleRpcStatus>;

export function useTraderPayinTraderServiceBalance<
    TData = Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayinTraderServiceBalance<
    TData = Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayinTraderServiceBalance<
    TData = Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить баланс трейдера.
 */

export function useTraderPayinTraderServiceBalance<
    TData = Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinTraderServiceBalance>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getTraderPayinTraderServiceBalanceQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return { ...query, queryKey: queryOptions.queryKey };
}
